import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar, Header } from 'components/layout';
import { Layout } from 'antd';
import { AuthProvider } from 'context';

const { Content } = Layout;

const DefaultLayout = ({ children }) => (
  <AuthProvider>
    <Layout className="main-layout">
      <Sidebar />
      <Layout>
        <Header />
        <Content className="content-wrapper">
          <div className="content">{children}</div>
        </Content>
      </Layout>
    </Layout>
  </AuthProvider>
);

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DefaultLayout;
